import {z} from 'zod';

import i18n from '@dms/i18n';

export const TransferOrderCreateFormSchema = z.object({
  transferOrderVariantId: z.string().nonempty({message: i18n.t('errors.field_is_required')}),
});

export type TransferOrderCreateForm = z.infer<typeof TransferOrderCreateFormSchema>;
